import { render, staticRenderFns } from "./ExpireDetail.vue?vue&type=template&id=d72a2b80&scoped=true&"
import script from "./ExpireDetail.vue?vue&type=script&lang=js&"
export * from "./ExpireDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72a2b80",
  null
  
)

export default component.exports